import getCardBrand from 'credit-card-type';
import configService from './configService';
import creditCardTypes from '../data/creditCardTypes';
import parameterService from "./parameterService";

class CreditCardService {

    constructor() {
        this.coBadgedCards = [];
        try {
            configService.getCoBadgedCards(data => {
                if (!data instanceof Array) {
                    return;
                }
                this.coBadgedCards = data;
            })
        } catch(err) {}
        this.creditCardTypes = null;
    }

    getCreditCardTypes() {
        if (this.creditCardTypes instanceof Array) {
            return this.creditCardTypes;
        }

        if (!parameterService.payTypes) {
            this.creditCardTypes = [];
            return this.creditCardTypes;
        } else if (parameterService.payTypes.length === 1 && parameterService.payTypes[0] === 'CC') {
            this.creditCardTypes = creditCardTypes;
            return this.creditCardTypes;
        }

        const filteredPayTypes = [];

        parameterService.payTypes.forEach(payType => {
            let matchingPayTypes = creditCardTypes.filter(ele => ele.apiType === 'CC_' + payType);
            if (matchingPayTypes.length === 0) {
                return;
            }
            filteredPayTypes.push(matchingPayTypes[0]);
        });

        this.creditCardTypes = filteredPayTypes;
        return this.creditCardTypes;
    }

    getMatchingBrands(cardNumber) {
        return getCardBrand(cardNumber);
    }

    cleanCardNumber(cardNumber) {
        return cardNumber.replace(/[^0-9]/g, '');
    }

    // checks if the cardNumber contains only valid characters
    cardNumberValidChars(cardNumber) {
        if (typeof cardNumber !== 'string') {
            return false;
        }
        return /^[\d\s]+$/.test(cardNumber);
    }

    insertSpacesToCardNumber(cardNumber, cursorIndex) {
        let cleanedCardNumber = this.cleanCardNumber(cardNumber).slice(0, 19);

        const matchingBrands = this.getMatchingBrands(cleanedCardNumber);
        let gaps = [4,8,12];

        if (matchingBrands.length === 1) {
            gaps = matchingBrands[0].gaps;
        }

        const components = [];

        for (let x = 0; x < gaps.length; x++) {
            if (cleanedCardNumber.length <= gaps[x]) {
                components.push(cleanedCardNumber.slice(gaps[(x === 0)] ? 0 : gaps[x - 1], cleanedCardNumber.length));
                return components.join(' ');
            }
            components.push(cleanedCardNumber.slice(gaps[(x === 0)] ? 0 : gaps[x - 1], gaps[x]));
        }
        components.push(cleanedCardNumber.slice(gaps[gaps.length - 1], cleanedCardNumber.length));
        return components.join(' ');
    }

    formatCardNumber(cardNumber) {
        const cleanedCardNumber = this.cleanCardNumber(cardNumber);
        return this.insertSpacesToCardNumber(cleanedCardNumber, cleanedCardNumber.length);
    }

    checkCardNumber(cardNumber) {
        let cleanedCardNumber = this.cleanCardNumber(cardNumber);

        let matchingBrands = this.getMatchingBrands(cleanedCardNumber);

        if (matchingBrands.length !== 1) {
            return false;
        }

        if (matchingBrands[0].lengths.indexOf(cleanedCardNumber.length) === -1) {
            return false;
        }

        // accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(cleanedCardNumber)) {
            return false;
        }

        // The Luhn Algorithm.
        let nCheck = 0;
        let bEven = false;
        cleanedCardNumber = cleanedCardNumber.replace(/\D/g, '');

        for (let x = cleanedCardNumber.length - 1; x >= 0; x--) {
            let cDigit = cleanedCardNumber.charAt(x);
            let nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }

            nCheck += nDigit;
            bEven = !bEven;
        }

        return (nCheck % 10) === 0;
    }

    checkExpMonth(expMonth) {
        if (typeof expMonth !== 'string') {
            return false;
        }
        if (parseInt(expMonth, 10).toString() !== expMonth.replace(/^0+/, '')) {
            return false;
        }
        if (parseInt(expMonth, 10) <= 0) {
            return false;
        }
        if (parseInt(expMonth, 10) > 12) {
            return false;
        }
        return expMonth.length === 1 || expMonth.length === 2;
    }

    checkExpYear(expYear) {
        if (typeof expYear !== 'string') {
            return false;
        }
        if (parseInt(expYear, 10).toString() !== expYear.replace(/^0+/, '')) {
            return false;
        }
        return expYear.length === 2 || expYear.length === 4;
    }

    checkCheckNumber(checkNumber) {
        if (typeof checkNumber !== 'string') {
            return false;
        }
        if (parseInt(checkNumber, 10).toString() !== checkNumber.replace(/^0+/, '')) {
            return false;
        }
        return checkNumber.length === 3 || checkNumber.length === 4;
    }

    isCoBadgedCard(cleanedCardNumber) {
        if (cleanedCardNumber.length < 6) {
            return false;
        }

        while(cleanedCardNumber.length < 19) {
            cleanedCardNumber += '0';
        }

        cleanedCardNumber = parseInt(cleanedCardNumber, 10);

        for (let x = 0; x < this.coBadgedCards.length; x++) {
            if (cleanedCardNumber >= this.coBadgedCards[x].start && cleanedCardNumber <= this.coBadgedCards[x].end) {
                return true;
            }
        }
        return false;
    }

    isCoBadgedEnabled() {
        return parameterService.payTypes.indexOf('Cartes Bancaires') !== -1 || parameterService.payTypes.indexOf('CartesBancaires') !== -1;
    }

    formatExpirationInput(expirationDate, cursorIndex) {
        if (cursorIndex !== expirationDate.length) {
            return expirationDate;
        }

        if (expirationDate.length === 2 && expirationDate[1] === '/') {
            expirationDate = '0' + expirationDate;
        }

        let cleanedExpirationDate = expirationDate.replace(/[^\d]/g, '').slice(0, 4);

        if (cleanedExpirationDate.length < 3) {
            return cleanedExpirationDate;
        }
        return cleanedExpirationDate.slice(0,2) + ' / ' + cleanedExpirationDate.slice(2,4)
    }
}

export default new CreditCardService();



// WEBPACK FOOTER //
// ./src/services/creditCardService.js